interface SelectableMarketOutcome {
  readonly outcomeIndex: number | string;
  readonly label: string;
}

/** Applies the shared selection and silently keeps its deep link in sync. */
export function selectMarketDetailOutcome(input: {
  readonly marketPubkey: string;
  readonly index: number;
  readonly outcomes: readonly SelectableMarketOutcome[] | undefined;
  readonly setSelectedOutcome: (marketPubkey: string, index: number) => void;
}): void {
  input.setSelectedOutcome(input.marketPubkey, input.index);

  const label = input.outcomes?.find(
    (outcome) => Number(outcome.outcomeIndex) === input.index,
  )?.label;
  if (label === undefined || typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  params.set('outcome', label);
  const url = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
  window.history.replaceState(window.history.state, '', url); // ALLOW-NETWORK-UNAWARE: silent same-origin outcome-filter URL update; does not navigate.
}
